import { useEffect } from 'react';

export const Footer = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.innerHTML = `
function enviarEmail(e) {
  e.preventDefault();

  emailjs.send("service_ikq11of", "template_emlqxvv", {
    nome: document.getElementById("nome").value,
    whatsapp: document.getElementById("whatsapp").value,
    email: document.getElementById("email").value,
    mensagem: document.getElementById("mensagem").value
  })
  .then(function() {
    alert("✅ Mensagem enviada com sucesso!");
  }, function(error) {
    alert("❌ Erro ao enviar: " + error.text);
  });
}
    `;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <footer className="bg-card text-foreground relative overflow-hidden border-t border-border" role="contentinfo">
      <div className="absolute inset-0 opacity-5" aria-hidden="true">
        <div className="absolute bottom-0 left-1/4 w-96 h-96 bg-primary rounded-full blur-3xl" />
        <div className="absolute top-0 right-1/4 w-96 h-96 bg-accent rounded-full blur-3xl" />
      </div>
      
      <div className="container mx-auto px-4 py-8 lg:py-12 relative z-10">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-3 gap-6 lg:gap-8 mb-6 lg:mb-8">
            {/* Brand Section */}
            <div className="space-y-2 lg:space-y-3 text-center md:text-left">
              <h3 className="text-lg lg:text-xl font-bold text-primary">URA Humanizada</h3>
              <div className="h-1 w-16 lg:w-20 bg-gradient-primary rounded-full mx-auto md:mx-0" aria-hidden="true" />
              <p className="text-xs lg:text-sm text-muted-foreground leading-relaxed">
                Locutora Publicitária Profissional
              </p>
            </div>
            
            {/* Services Section */}
            <nav className="space-y-2 lg:space-y-3 text-center md:text-left" aria-label="Serviços">
              <h4 className="text-xs lg:text-sm font-semibold text-foreground uppercase tracking-wider">Serviços</h4>
              <ul className="space-y-1.5 lg:space-y-2 text-xs lg:text-sm text-muted-foreground">
                <li>Gravação de URA</li>
                <li>Voice Over Brasileiro</li>
                <li>Locução Publicitária</li>
                <li>
                  <a href="/uras-natal" className="text-highlight hover:underline transition-colors">
                    URAs de Natal e Ano Novo
                  </a>
                </li>
              </ul>
            </nav>
            
            {/* Contact Section */}
            <address className="space-y-2 lg:space-y-3 text-center md:text-left not-italic" aria-label="Informações de contato">
              <h4 className="text-xs lg:text-sm font-semibold text-foreground uppercase tracking-wider">Contato</h4>
              <div className="space-y-1.5 lg:space-y-2 text-xs lg:text-sm text-muted-foreground">
                <p>
                  <a href="tel:+5511910456805" className="hover:text-primary transition-colors" aria-label="Ligar para (11) 91045-6805">
                    (11) 91045-6805
                  </a>
                </p>
                <p className="break-all">
                  <a href="mailto:contatourahumanizada@gmail.com" className="hover:text-primary transition-colors" aria-label="Enviar email para contatourahumanizada@gmail.com">
                    contatourahumanizada@gmail.com
                  </a>
                </p>
              </div>
            </address>
          </div>
          
          {/* Bottom Bar */}
          <div className="pt-6 lg:pt-8 border-t border-border/20">
            <div className="flex flex-col md:flex-row justify-between items-center gap-2 lg:gap-4 text-xs lg:text-sm text-muted-foreground text-center md:text-left">
              <p>© 2021 URA Humanizada/VozdaEllen – Todos os direitos reservados</p>
              <p>CNPJ 42.903.290/0001-23</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
